// extracted by mini-css-extract-plugin
export default {"reset_wrapper":"reset_reset_wrapper__MwIFG","text":"reset_text__OtjSo"};